import axios from "axios";
import Config from "./index";

var backendUrl;

if (Config.ENV == "dev") {
  backendUrl = Config.BACKEND_URL.DEV;
} else if (Config.ENV == "production") {
  backendUrl = Config.BACKEND_URL.PRODUCTION;
} else {
  backendUrl = Config.BACKEND_URL.LOCAL;
}

const options = {
  baseURL: backendUrl,
  headers: {},
};

const client = axios.create(options);

export default client;
